import * as Cesium from "cesium"
import getChunks from "../viewerFuncs/getChunks"

const urlBuilder = (dataset, date, token, chunk) => {
    let url = `${process.env.REACT_APP_BASE_URL}/api/staticFiles/${dataset}/webTiles/${date}/${chunk}/tileset.json`
    const tilesetResource = new Cesium.Resource({
        url: url,
        headers: {
            'Cache-Control':'no-store',
            'token': token
        },
    });
    return tilesetResource


}

const chunkGather = (dataset, date, token) => {
    return new Promise(function (resolve, reject) {
        let response = getChunks(dataset, date, token)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.log(`chunk error: ${error}`)
            })

        setTimeout(function () {
            resolve(response)
        }, 500)
    })
}

const loadTileSet = (dataset, date, token, viewer, featureLabel, splitDir) => {
    let tileSetChunks = []
    chunkGather(dataset, date, token).then((chunks)=>{
        for (let i = 0; i<chunks.length;i++){
            console.log(`chunk gather loop, array instance: ${chunks[i]}`)
            const tileSet = new Cesium.Cesium3DTileset({
                url: urlBuilder(dataset, date, token, chunks[i]),
                //maximumScreenSpaceError: 1,
                //preloadWhenHidden: true,
                //foveatedScreenSpaceError: false,
                //skipLevelOfDetail: false,
                splitDirection: splitDir,
                maximumMemoryUsage: 2048,
                featureIdLabel: featureLabel
            })
            const clippingPlanes = new Cesium.ClippingPlaneCollection({
                planes : [
                    new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, 1.0, 0.0), 10)
                ]
            })
            viewer.scene.primitives.add(tileSet, {
                position : Cesium.Cartesian3.fromDegrees(36.298, -94.188),
                minimumPixelSize : 1,
                maximumScale : 20000,
                clippingPlanes : clippingPlanes
            });
            tileSetChunks.push(tileSet)
        }
    })

}

export default loadTileSet;
